import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expenditure-form',
  templateUrl: './expenditure-form.component.html',
  styleUrls: ['./expenditure-form.component.css']
})
export class ExpenditureFormComponent implements OnInit {

  title = "Add Expenditure";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/finance/expenditure/expenditure-form/expenditure-form.component.ts